<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import IntegrationsOverview from "../components/IntegrationsOverview.vue";

const breadcrumbs = [
	{
		title: "Integrations",
		disabled: true,
		to: "/integrations",
	},
];
</script>

<template>
	<main-breadcrumbs :breadcrumbs="breadcrumbs" />
	<integrations-overview />
</template>

<style lang="scss"></style>
